import { createFileRoute, redirect } from '@tanstack/react-router';

// /profile lands on the Account tab (the only tab today).
export const Route = createFileRoute('/_learner/profile/')({
  beforeLoad: () => {
    throw redirect({ to: '/profile/account' });
  },
});
